import { ReactNode } from "react";
import Button from "../Components/button";
import Checkbox from "./checkbox";
import { useNavigationContext } from "../Context/NavigationContext";
import Loading from "./loading";
import { object, string } from 'yup';
import Notify from "../Utils/Notify";
import Toggle from "./toggle";
import Select from "./select";
import { FormOptions, FormField } from "../Types";
import { capsToSentenceCase } from "../Utils/String";
import { Grid2 as Grid } from '@mui/material';

export const Form = ({ fields, submit, buttonText, buttonClass, buttonWrapperClass, loading, horizontal }: FormOptions) => {

    const { changeLandingView } = useNavigationContext();

    const schema = object(fields.map((field) => {
            return {
                [field.label]: field.required
                ? string().required()
                : string(),
            };
        }).reduce((acc, field) => ({ ...acc, ...field }), {})
    );

    const handleSubmit = async (e: any) => {
        if(e) e.preventDefault();
        try {
            await schema.validate(
                fields.reduce((acc, field) => ({ ...acc, [field.label]: field.value ?? '' }), {})
            );
            submit();
        } catch (error: any) {
            Notify('error', capsToSentenceCase(error.errors ? error.errors[0] : ''));
        }
    };

    return (
        <form 
            className="form-wrapper" 
            autoComplete="on"
            onSubmit={handleSubmit}
        >
            {
                horizontal ? 
                <Grid container spacing={5}>
                    {
                        fields.map((field, index) => (
                            <Grid size={{ xs: 12, lg: 6 }} key={index}>
                                <div style={{ marginBottom: '10px', fontSize: '1.1vw' }}>{field.label}</div>
                                {getField(field, index, handleSubmit)}
                            </Grid>
                        ))
                    }
                </Grid>
                :
                fields.map((field, index) => (
                    <div className={
                        'input-wrapper' +
                        (field.type === 'checkbox' ? ' form-checkbox' : '') +
                        (field.type === 'toggle' ? ' form-toggle' : '')         
                    } 
                        key={index}
                    >
                        <label>
                            {field.label}
                            {  
                                field.forgotPassword && 
                                <span className="forgot-password" onClick={() => changeLandingView('forgotPassword')} >
                                    forgot password?
                                </span>
                            }
                        </label>
                        {getField(field, index, handleSubmit)}
                    </div>
                ))
            }
            <div className={`button-wrapper ${buttonWrapperClass ?? ''}`}>
            {loading ? 
                <Loading /> 
                :
                <Button 
                    text={buttonText}
                    onClick={handleSubmit}
                    className={buttonClass}
                />
            }
            </div>
        </form>
    );
}

export const getField = (field: FormField, index: number, onEnterPress: Function) : ReactNode => {
    if (field.type === 'email') {
        return (
            <input
                key={index}
                type="email"
                placeholder={field.placeholder}
                value={field.value}
                onChange={(e) => field.setValue(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
                name='username'
                autoComplete="email"
            />
        );
    } else if (field.type === 'password') {
        return (
            <input
                key={index}
                type="password"
                placeholder={field.placeholder}
                value={field.value}
                onChange={(e) => field.setValue(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
                name='password'
                autoComplete="current-password"
                style={{backgroundColor: 'transparent !important'}}
            />
        );
    } else if(field.type === 'text') {
            return (
                <input 
                    key={index}
                    type={field.type}
                    placeholder={field.placeholder}
                    value={field.value}
                    onChange={(e) => field.setValue(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
                    name={field.name ?? ''}
                    autoComplete={field.name ?? ''}
                />
            );
    } else if(field.type === 'select') {
        return (
            <Select
                key={index}
                options={field.values?.map(v => ({ ...v, value: v.value ?? '' })) ?? []}
                value={field.value}
                setValue={field.setValue}
                defaultText={field.placeholder}
                hasSearch={field.filterable ?? false}
                initKey={field.startKey}
            />
        )
    } else if(field.type === 'checkbox') {
        return (
            <div className="form-checkbox-wrapper">
                <Checkbox
                    key={index}
                    label={''}
                    value={field.value}
                    setValue={field.setValue}
                />
            </div>
        );
    } else if(field.type === 'toggle') {
        return (
            <div className="form-toggle-wrapper">
                <Toggle
                    key={index}
                    value={field.value}
                    setValue={field.setValue}
                    rightLabel="NO"
                    leftLabel="YES"
                />
            </div>
        );
    }
}